import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IdentificationCheckOnAppPage } from './identification-check-on-app';

@NgModule({
  declarations: [
    IdentificationCheckOnAppPage,
  ],
  imports: [
    IonicPageModule.forChild(IdentificationCheckOnAppPage),
  ],
  exports: [
    IdentificationCheckOnAppPage
  ]
})
export class IdentificationCheckOnAppPageModule { }



// WEBPACK FOOTER //
// ./src/pages/identification-check-on-app/identification-check-on-app.module.ts